import { compose } from 'redux'

import withEventHandlers from './withEventHandlers'

// presentational component
import UI from './UI'

export default compose(withEventHandlers)(UI)
